import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { server } from "../../common";
import { AxiosError } from "axios";
import { NavLink } from "react-router-dom";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";
import ShareModal from "../../ShareModal";
import { shareurl } from "../../config";
import configContext from "../../context/configContext/configContext";

const News = () => {
  document.title = "News";
  const [news, setNews] = useState([]);
  const [industrynews, setIndustryNews] = useState([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const [sharedTitle, setSharedTitle] = useState("");
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  useEffect(() => {
    getData();
    getIndustryData();
  }, []);

  // Function to open the Share modal
  const openShareModal = (url, title) => {
    setSharedTitle(title);
    setShowShareModal(true);
  };

  // Function to close the Share modal
  const closeShareModal = () => {
    setShowShareModal(false);
  };

  // Get
  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/news/getallnews", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setNews(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // Get industry
  const getIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/news/getallind_news", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryNews(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/news/searchallnews?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryNews(response.data);
          setNews(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/news/filter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setNews(response.data);
          setIndustryNews(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterCategoryData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/news/searchallnews?search=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setNews(response.data);
          setIndustryNews(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // const news = [
  //   {
  //     id: 1,
  //     title:
  //       "Warmest decade in history also saw drop in deaths from ‘extreme climate events’: World Meteorological Organisation",
  //     img: "https://th-i.thgim.com/public/incoming/1jr780/article67608509.ece/alternates/LANDSCAPE_660/YAMUNA_STANDALONE_2022_02_05_4.jpg",
  //   },
  //   {
  //     id: 2,
  //     title:
  //       "Prime Minister Narendra Modi pay tributes to B..R. Ambedkar at Parliament House on Wednesday. | Photo Credit: Sushil Kumar Verma      ",
  //     img: "https://th-i.thgim.com/public/incoming/x89ch0/article67609865.ece/alternates/LANDSCAPE_1200/WhatsApp%20Image%202023-12-06%20at%2009.01.40.jpeg",
  //   },
  //   {
  //     id: 3,
  //     title:
  //       "BJP workers celebrate party's victory in Rajasthan, Madhya Pradesh and Chhattisgarh. ",
  //     img: "https://www.hindustantimes.com/ht-img/img/2023/12/06/550x309/BJP-workers-celebrate-party-s-victory-in-Rajasthan_1701830346123_1701830382531.jpg",
  //   },
  //   {
  //     id: 4,
  //     title:
  //       "MPs attend the proceeding of the House during the Winter session of Parliament, in New Delhi, Wednesday, Dec. 6 (PTI) ",
  //     img: "https://www.hindustantimes.com/ht-img/img/2023/12/06/550x309/MPs-attend-the-proceeding-of-the-House-during-the-_1701853283730.jpg",
  //   },
  // ];

  return (
    <>
      <div className="container py-5">
        <h2 className="text-start mb-5 fw-bold border-start border-4 ps-3 border-danger">
          ताज्या बातम्या
        </h2>
        <div className="row">
          {news.map((news, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className="card news-card shadow-sm h-100 rounded-4 border-0 overflow-hidden position-relative">
                <div className="position-relative">
                  <img
                    src={news.image}
                    className="card-img-top img-fluid"
                    alt={news.title}
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <span className="badge bg-danger position-absolute top-0 end-0 m-2">
                    {new Date(news.date).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </div>
                <div className="card-body bg-white">
                  <h5 className="card-title fw-semibold text-center text-dark">
                    {news.title}
                  </h5>
                  {/* <p className="card-text text-muted small">
                    {news.description.length > 100
                      ? news.description.slice(0, 100) + "..."
                      : news.description}
                  </p> */}
                  {/* <a href="#" className="btn btn-sm btn-outline-danger mt-2">
                    Read More →
                  </a> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <ShareModal
        showModal={showShareModal}
        handleClose={closeShareModal}
        url={`https://yuvasarathi.com/#/news`}
        title={sharedTitle}
      />
    </>
  );
};

export default News;
